var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_WhatsApp_16x16",
    "data-name": "Icon WhatsApp 16x16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35903",
    "data-name": "Rectangle 35903",
    width: 16,
    height: 16,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1 0.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43373",
    "data-name": "Group 43373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367320",
    "data-name": "Path 367320",
    d: "M14.967,4a6.967,6.967,0,0,0-11.9,4.9A6.6,6.6,0,0,0,4,12.371l-1,3.6L6.7,15a6.767,6.767,0,0,0,3.333.833A6.933,6.933,0,0,0,14.967,4ZM10.033,14.671a5.7,5.7,0,0,1-3.167-.933l-2.2.6.6-2.133A5.967,5.967,0,0,1,4.233,8.9a5.8,5.8,0,1,1,5.8,5.767Z",
    transform: "translate(-3 -1.956)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367321",
    "data-name": "Path 367321",
    d: "M20.2,17.857a9.733,9.733,0,0,0-1.2-.567c-.133-.067-.267-.1-.367.067s-.467.567-.567.7a.267.267,0,0,1-.367.033,5.067,5.067,0,0,1-1.4-.867,5,5,0,0,1-.967-1.2.233.233,0,0,1,.067-.333l.267-.333a1.167,1.167,0,0,0,.167-.267.3.3,0,0,0,0-.3c-.067-.1-.4-.933-.533-1.3s-.3-.3-.4-.3h-.333a.567.567,0,0,0-.467.233,1.833,1.833,0,0,0-.6,1.433,3.467,3.467,0,0,0,.7,1.8,7.932,7.932,0,0,0,2.967,2.6,5.467,5.467,0,0,0,1,.367,2.133,2.133,0,0,0,1.1.067,1.683,1.683,0,0,0,1.167-.8,1.366,1.366,0,0,0,.1-.833A.7.7,0,0,0,20.2,17.857Z",
    transform: "translate(-9.997 -9.443)",
    fill: "#1d1d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.aa94ef9c509d1b5dd4d6ff3984e4b5d6.svg";
export { ForwardRef as ReactComponent };